// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.vendorsandpartners.claimsprocessor.ExternalCredentialLocationResponse */
/* istanbul ignore next */
@GandalfModel
export class ExternalCredentialLocationResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Boolean })
	active!: boolean;

	@GandalfProperty({ designType: Number })
	credentialId!: number;

	@GandalfConstantDecorator(constants.ExternalSystem)
	@GandalfProperty({ designType: constants.ExternalSystem })
	externalSystem!: constants.ExternalSystem;

	@GandalfProperty({ designType: String })
	password!: string;

	@GandalfProperty({ designType: Number })
	practiceLocationId!: number;

	@GandalfProperty({ designType: String })
	practiceLocationName!: string;

	@GandalfProperty({ designType: String })
	userName!: string;

}
